import type { RootState } from '../store';

const isInitialized = (state: RootState) => state.authentication.isInitialized;

const isLoading = (state: RootState) => state.authentication.isLoading;

const isInitLoading = (state: RootState) => state.authentication.isInitLoading;

const isLoginLoading = (state: RootState) => state.authentication.isLoginLoading;

const isAuthenticated = (state: RootState) => state.authentication.isAuthenticated;

const salt = (state: RootState) => state.authentication.salt;

const getErrorMessage = (state: RootState): string | undefined | null => state.authentication.errorMessage;

const authenticationSelector = {
  isInitialized,
  isLoading,
  isInitLoading,
  isLoginLoading,
  isAuthenticated,
  salt,
  getErrorMessage,
};

export default authenticationSelector;
